import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const ModalConfirmacion = ({ open, handleClose, texto, tipo, id }) => {
    return (
        <>
            <Dialog
                open={open}
                onClose={() => handleClose(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>Confirmación</DialogTitle>
                <DialogContent>
                    <DialogContentText>{texto}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose(false)} color="error" variant="contained">
                        Cancelar
                    </Button>
                    <Button onClick={() => handleClose(true, tipo, id)} color="success" variant="contained">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ModalConfirmacion